import styled from 'styled-components'
import Button from '@components/Button'

export const BulkFormWrapper = styled.div`
  margin-top: -15px;
`

export const BulkFormField = styled.div`
  ${({ theme }) => `
    padding: 5px 11.5px 4.5px;
    border-radius: 6px;
    background-color: ${theme.palette.blue10};
    font-size: ${theme.fontSize.xs};
    font-weight: ${theme.fontWeight.bold};
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    flex-grow: 0;

    label {
      margin-right: ${theme.space.xs};
      flex-shrink: 0;
    }

    &.mobile {
      padding: 9.5px 11.5px 13px;
      flex-direction: column;
      align-items: flex-start;
      flex-grow: 1;

      label {
        margin-bottom: ${theme.space.xs};
      }
    }
  `}
`

export const AddButton = styled(Button)`
  border-radius: 100%;
  width: 38px;
  height: 38px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 19px;
    height: 19px;
  }
`

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-grow: 1;
  margin-top: ${({ theme }) => theme.space.xxs};
  margin-bottom: ${({ theme }) => theme.space.xxs};

  button {
    flex-shrink: 0;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    align-self: center;
  }
`

export const FormBox = styled.div`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: flex;
    flex-direction: column;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    flex-direction: column;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    display: flex;
    flex-direction: row;
  }
`

export const FormDateBox = styled.div`
  display: flex;
  margin-right: ${({ theme }) => theme.space.xs};
  height: 48px;
  margin-top: ${({ theme }) => theme.space.xxs};
  margin-bottom: ${({ theme }) => theme.space.xxs};
`

export const FormDayTimeAddSearchBox = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  margin-top: ${({ theme }) => theme.space.xxs};
  margin-bottom: ${({ theme }) => theme.space.xxs};

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    margin-top: ${({ theme }) => theme.space.xxs};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    margin-top: ${({ theme }) => theme.space.xxs};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    margin-top: ${({ theme }) => theme.space.xxs};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
`

export const FormDayTimeAddBox = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: ${({ theme }) => theme.space.xxs};

  ${BulkFormField} {
    margin-right: ${({ theme }) => theme.space.xs};

    &.mobile {
      margin-right: 0;
      margin-bottom: ${({ theme }) => theme.space.xxs};
    }
  }

  button {
    margin-left: ${({ theme }) => theme.space.xs};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    align-items: center;

    button {
      margin-left: 0;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    align-items: center;

    button {
      margin-left: 0;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    align-items: center;
    width: max-content;
    flex-wrap: wrap;

    button {
      margin-left: 0;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    align-items: center;
    width: max-content;
    justify-content: flex-start;

    button {
      margin-left: 0;
    }
  }
`

export const FormModalBox = styled.div`
  display: block;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: none;
  }
`

export const ModalAction = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
`

export const BinButton = styled(Button)`
  background-color: white;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0;
  margin-top: -1px;
  margin-left: 8px !important;

  svg {
    width: 16px;
    height: 16px;
  }
`
